export default __webpack_public_path__ + "media/images/banners/months/bnr_11-a03d9a2cbcd1a9a25feae6f338d527e6.jpg";